type ApplicationPageContentProps = {
  children: React.ReactNode;
  title: string;
  description?: string | React.ReactNode;
};

export const ApplicationPageContent = (props: ApplicationPageContentProps) => {
  const { children, title, description } = props;

  return (
    <div className='flex flex-col gap-8 py-8 w-[320px] md:w-[460px] md:min-h-[calc(100vh-168px]'>
      <div className='flex flex-col gap-2'>
        <h1 className='text-display-xs font-medium text-gray-700'>{title}</h1>
        {description && <div>{description}</div>}
      </div>
      {children}
    </div>
  );
};
